// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  ICianApiSiteV1GetLocationRequest,
  TCianApiSiteV1GetLocationModel,
  IMappers,
  TCianApiSiteV1GetLocationResponse,
  TCianApiSiteV1GetLocationResponse_1,
  TCianApiSiteV1GetLocationResponseError,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';

export const defaultConfig: TCianApiSiteV1GetLocationModel = {
  apiType: 'legacy',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'monolith-python',
  pathApi: '/cian-api/site/v1/get-location/',
  interserviceAuthEnabled: true,
} as TCianApiSiteV1GetLocationModel;

export function createCianApiSiteV1GetLocationModel(
  parameters: ICianApiSiteV1GetLocationRequest,
): TCianApiSiteV1GetLocationModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface ICianApiSiteV1GetLocationOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: ICianApiSiteV1GetLocationRequest;
}

export async function fetchCianApiSiteV1GetLocation<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ICianApiSiteV1GetLocationOptions<TResponse200, TResponse400>): Promise<
  TCianApiSiteV1GetLocationResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(
    createCianApiSiteV1GetLocationModel(parameters),
    config,
  );
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TCianApiSiteV1GetLocationResponse_1);
    }
    if (statusCode === 400) {
      return mappers[400](response as TCianApiSiteV1GetLocationResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TCianApiSiteV1GetLocationResponse;
}
